<template>
  <div class="white-container full-page-container common-table">
    <el-button size="small" type="primary" icon="el-icon-plus" style="position: absolute;top: -50px;right: 0;" @click="add">新增</el-button>
    <el-form class="search-bar" :inline="true" size="small">
      <el-form-item label="活动城市">
        <el-select v-model="search.uaEventCityId" placeholder="选择活动城市" clearable>
          <el-option v-for="city in cityList" :key="city.id" :label="city.name" :value="city.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="活动状态">
        <el-select v-model="search.status" placeholder="选择活动状态" clearable>
          <el-option v-for="item in activityStatus" :key="item.id" :label="item.value" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="赛事类型">
        <el-select v-model="search.activityMode" placeholder="选择赛事类型" clearable>
          <el-option v-for="type in activityModeList" :key="type.id" :label="type.value" :value="type.id" />
        </el-select>
      </el-form-item>
      <el-form-item class="search-form-item">
        <el-input v-model="search.keyword" placeholder="输入你想搜索的文字" prefix-icon="el-icon-search" />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="searchSubmit">查询</el-button>
        <el-button @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <tableList ref="multipleTable" :table-query="search" :query-function="queryFunction" :deal-data="dealData" size="small" style="width: 100%">
      <el-table-column prop="id" label="活动ID" width="80" fixed />
      <el-table-column prop="activityModeName" label="赛事类型" width="120" />
      <el-table-column prop="name" label="活动标题" />
      <el-table-column prop="status" label="活动状态">
        <template slot-scope="scope">
          <span class="activity-status-tag" :style="activityStatus[scope.row.status]?.style">{{ activityStatus[scope.row.status]?.value }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="beginTime" label="活动开始日期" />
      <el-table-column prop="cityName" label="活动城市" />
      <el-table-column prop="participationNumber" label="报名人数/队伍" />
      <el-table-column prop="isShow" label="是否在列表页展示">
        <template slot-scope="scope">
          <span>{{ scope.row.isShow === 0 ? '是' : '否' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" />
      <el-table-column fixed="right" width="380px" label="操作">
        <template slot-scope="{row}">
          <el-button v-if="row.status === 1" size="small" type="text" class="link-color" @click="publish(row)">发布</el-button>
          <el-button v-if="row.status === 1 || (row.isLongTermActivity === 1 && [2, 3].includes(row.status))" size="small" type="text" class="link-color" @click="edit(row)">编辑</el-button>
          <el-button size="small" type="text" class="link-color" @click="copy(row)">复制</el-button>
          <el-button v-if="row.status != 1" size="small" type="text" class="link-color" @click="downloadRegistrationList(row)">报名名单</el-button>
          <el-button v-if="[3, 4, 5, 6].includes(row.status)" size="small" type="text" class="link-color" @click="downloadIdCardList(row)">身份证信息表</el-button>
          <el-button v-if="[3, 4, 5, 6].includes(row.status)" size="small" type="text" class="link-color" @click="getMatchCode(row)">参赛码</el-button>
          <el-button v-if="row.status != 6" size="small" type="text" class="link-color" @click="remove(row)">删除</el-button>
        </template>
      </el-table-column>
    </tableList>
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="submitSucces" />
  </div>
</template>
<script>
import tableList from '@/components/TableList';
import Dialog from '@/components/Dialog';
import { subActivityList, subActivityCityList as fetchCityList, exportSubActivity, exportIdCard, exportCheckCode, deleteSubActivity, publishSubActivity } from '@/api/combine';

export default {
  components: { tableList, Dialog },
  data() {
    const activityStatus = {
      1: { value: '草稿', style: 'background: #EA99211A; border: 1px solid #EA9921B2; color: #EA9921;', id: 1 },
      2: { value: '已发布', style: 'background: #1890FF1A; border: 1px solid #1890FFB2; color: #1890FF;', id: 2 },
      3: { value: '开放报名中', style: 'background: #52C41A1A; border: 1px solid #52C41AB2; color: #52C41A;', id: 3 },
      4: { value: '报名已截止', style: 'background: #FAAD141A; border: 1px solid #FAAD14B2; color: #FAAD14;', id: 4 },
      5: { value: '活动进行中', style: 'background: #1890FF1A; border: 1px solid #1890FFB2; color: #1890FF;', id: 5 },
      6: { value: '已结束', style: 'background: #4949491A; border: 1px solid #9B9B9BB2; color: #9B9B9B;', id: 6 },
    };
    return {
      search: {
        uaEventCityId: '',
        status: '',
        activityMode: '',
        type: '',
        keyword: '',
      },
      activityStatus,
      cityList: [],
      activityModeList: [
        { id: 0, value: '常规赛' },
        { id: 1, value: '计时团队赛' },
        { id: 2, value: '计时个人赛' },
      ],
      formDialogShow: false,
      currentID: -1,
      information: [],
      queryFunction: subActivityList,
    };
  },
  activated() {
    this.$refs.multipleTable.getTableList();
  },
  created() {
    this.getCityList();
  },
  methods: {
    async getCityList() {
      const res = await fetchCityList();
      this.cityList = res || [];
    },
    dealData(res) {
      if (res?.length) {
        res.forEach(item => {
          item.beginTime && (item.beginTime = this.$moment(item.beginTime).format('YYYY.MM.DD'));
          item.createTime && (item.createTime = this.$moment(item.createTime).format('YYYY/MM/DD HH:mm:ss'));
        });
      }
      return res || [];
    },
    add() {
      this.$router.push({ path: '/nextCombine/subActivity/add' });
    },
    edit(row) {
      this.formDialogShow = true;
      this.currentID = row.id;
      const statusText = this.activityStatus[row.status]?.value || '';
      const subTitle = `是否确认编辑活动ID为"${row.id}"，状态为"${statusText}"的数据项？`;
      this.information = {
        operation: 'edit',
        icon: 'warn',
        subTitle,
      };
    },
    remove(row) {
      this.formDialogShow = true;
      this.currentID = row.id;
      this.information = {
        operation: 'delete',
        icon: 'warn',
        subTitle: '确认后删除活动并触发“活动取消通知”订阅推送及SMS',
      };
    },
    copy(row) {
      this.formDialogShow = true;
      this.currentID = row.id;
      this.information = {
        operation: 'copy',
        icon: 'success',
        subTitle: `复制成功！是否进入新增页面？`,
      };
    },
    submitSucces(operation) {
      if (operation === 'delete') {
        this.formDialogShow = false;
        deleteSubActivity(this.currentID).then(() => {
          this.$message.success('删除成功');
          const tableData = this.$refs['multipleTable'].$data.tableData || [];
          const currentPage = this.$refs['multipleTable'].paginationParams.current;
          if (tableData.length === 1 && currentPage > 1) {
            this.$refs['multipleTable'].paginationParams.current = currentPage - 1;
          }
          this.$refs['multipleTable'].getTableList();
        });
      } else if (operation === 'copy') {
        this.$router.push({ path: '/nextCombine/subActivity/add', query: { copyid: this.currentID } });
      } else if (operation === 'edit') {
        this.$router.push({ path: '/nextCombine/subActivity/edit', query: { id: this.currentID } });
      } else if (operation === 'publish') {
        this.formDialogShow = false;
        publishSubActivity(this.currentID).then(() => {
          this.$message.success('发布成功');
          this.$refs['multipleTable'].getTableList();
        });
      }
    },
    searchSubmit() {
      this.$refs['multipleTable'].searchAndReset();
    },
    reset() {
      this.search = this.$options.data.call(this).search;
      this.$nextTick(() => {
        this.$refs['multipleTable'].searchAndReset();
      });
    },
    publish(row) {
      this.formDialogShow = true;
      this.currentID = row.id;
      this.information = {
        operation: 'publish',
        icon: 'warn',
        subTitle: `是否确认发布活动ID为"${row.id}"的数据项？`,
      };
    },
    downloadRegistrationList(row) {
      exportSubActivity(row.id);
    },
    downloadIdCardList(row) {
      exportIdCard(row.id);
    },
    getMatchCode(row) {
      exportCheckCode(row.id);
    },
  },
};
</script>
<style scoped lang="less">
.activity-status-tag {
  display: inline-block;
  min-width: 100px;
  height: 22px;
  line-height: 22px;
  padding: 0 8px;
  border-radius: 0;
  font-size: 14px;
  text-align: center;
}
</style>
